// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_e2-0";